/** 校验环境能否使用dom */
export var canUseDom = !!(typeof window !== "undefined" && typeof document !== "undefined" && window.document && window.document.createElement);
/** 校验是否是Android手机环境打开 */
export function isAndroid() {
  return canUseDom ? /android/.test(navigator.userAgent.toLowerCase()) : false;
}
/** 校验是否能在IOS环境打开 */
export function isIOS() {
  return canUseDom ? /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()) : false;
}